export default __webpack_public_path__ + "static/media/Dollar2.608cf233.jpeg";